import React from 'react';
import styled from 'styled-components';

import { formatPriceByLocale } from 'utils/utils';

export default function OrderInvoiceTotalPrice({ totalPrice }) {
  return (
    <TotalPriceSection>
      <PriceLabel>{'총 결제 금액'}</PriceLabel>
      <Price>{`${formatPriceByLocale('ko', totalPrice)}원`}</Price>
    </TotalPriceSection>
  )
}

const TotalPriceSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items:  center;
  margin-top: calc(100vw * (21 / 375));
  padding-bottom: calc(100vw * (33 / 375));
`;

const PriceLabel = styled.span`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (19.2 / 375));
  color: #121212; 
`;

const Price = styled.span`
  font-size: calc(100vw * (20 / 375));
  font-weight: 700;
  line-height: calc(100vw * (24 / 375));
  color: #121212; 
`